/** Built once: `toLocaleTimeString` with options constructs a formatter on every call. */
const TIME_FORMAT = new Intl.DateTimeFormat("en-US", {
  hour12: false,
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
});

/**
 * Formats a timestamp as HH:MM:SS, or HH:MM:SS.mmm with `ms`, for DevTools logs.
 * @param {number} timestamp - Date.now() value
 * @param {{ms?: boolean}} [options]
 * @returns {string}
 */
const formatTime = (timestamp, { ms = false } = {}) => {
  const hms = TIME_FORMAT.format(timestamp);
  return ms ? `${hms}.${String(new Date(timestamp).getMilliseconds()).padStart(3, "0")}` : hms;
};

export default formatTime;
